import { Typography } from '@automata/ui';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { ChangeEvent } from 'react';

import { getWarningMessage } from './utils';

export type PlanConfirmationCheckboxProps = {
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  syncedPlanId: string | null;
  lastSuccessfulPlanId: string | null;
  savedBatchNumber: number;
  inputBatchNumber: number | null;
  publishWithPlan: boolean;
};

const PlanConfirmationCheckbox = ({
  onChange,
  syncedPlanId,
  lastSuccessfulPlanId,
  savedBatchNumber,
  inputBatchNumber,
  publishWithPlan,
}: PlanConfirmationCheckboxProps): JSX.Element | null => {
  const warningMessage = getWarningMessage(
    syncedPlanId,
    lastSuccessfulPlanId,
    savedBatchNumber,
    inputBatchNumber
  );

  const showWarningText = warningMessage && publishWithPlan;

  if (!lastSuccessfulPlanId) {
    return null;
  }

  return (
    <div>
      <FormControlLabel
        label="Publish latest output plan"
        control={<Checkbox checked={publishWithPlan} onChange={onChange} />}
      />
      {showWarningText && (
        <Typography fontSize="small" color="warning">
          {warningMessage}
        </Typography>
      )}
    </div>
  );
};

export default PlanConfirmationCheckbox;
